import { render, staticRenderFns } from "./compEdit.vue?vue&type=template&id=498d6b25&scoped=true"
import script from "./compEdit.vue?vue&type=script&lang=js"
export * from "./compEdit.vue?vue&type=script&lang=js"
import style0 from "./compEdit.vue?vue&type=style&index=0&id=498d6b25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d6b25",
  null
  
)

export default component.exports